<template>
    <App
      v-bind="$attrs"
      v-on="$listeners"
      :sessionId="sessionId"
      :onClickLink="onClickLink"
      :onClickBack="onClickBack"
      :isFullWidth="isFullWidth"
    >
      <SMS v-if="page === 'sms'" @is-full-width-change="setIsFullWidth"/>
      <Types v-else-if="page === 'types'" @is-full-width-change="setIsFullWidth"/>
      <Total v-else-if="page === 'total'" @is-full-width-change="setIsFullWidth"/>
      <Summary v-else-if="page === 'summary'" @is-full-width-change="setIsFullWidth"/>
      <Traffic v-else-if="page === 'traffic'" @is-full-width-change="setIsFullWidth" />
      <CallLogs v-else-if="page === 'call-logs'" @is-full-width-change="setIsFullWidth"/>
      <PerNumber v-else-if="page === 'per-number'" @is-full-width-change="setIsFullWidth"/>
      <PerExtension v-else-if="page === 'per-extension'" @is-full-width-change="setIsFullWidth"/>
      <GeoDistribution v-else-if="page === 'geo-distribution'" @is-full-width-change="setIsFullWidth"/>
    </App>
  </template>

  <script>
  import {
    SMS,
    Types,
    Total,
    Summary,
    Traffic,
    CallLogs,
    PerNumber,
    PerExtension,
    GeoDistribution
  } from 'reports-components'
  import App from '../elements/functional-components/App.vue';
  
  export default {
    data() {
      return {
        isFullWidth: false,
      };
    },
    props:{
      sessionId: {
        type: String,
        required: false,
      },
      page: {
        type: String,
        required: true,
        validator: (v) => [
            'sms',
            'total',
            'types',
            'summary',
            'traffic',
            'call-logs',
            'per-number',
            'per-extension',
            'geo-distribution',
        ].includes(v),
      },
      onClickLink: {
        type: Function,
      },
      onClickBack: {
        type: Function,
      }
    },
    components: {
      App,
      SMS,
      Types,
      Total,
      Summary,
      Traffic,
      CallLogs,
      PerNumber,
      PerExtension,
      GeoDistribution
    },
    watch: {
      page() {
        this.isFullWidth = false;
      },
    },
    methods: {
      setIsFullWidth(isFullWidth) {
        this.isFullWidth = isFullWidth;
      },
    },
  };
  </script>

  <style lang="scss">
      @import 'vue-apps-assets/styles/scss/styles.scss';
  </style>
